//  域名
 const url = 'https://www.aodesusa.com/' //https://service.aodes.com
 export default {
    url
 }